// create
export const CREATE_DISBURSE_THRESHOLD_REQUEST = "CREATE_DISBURSE_THRESHOLD_REQUEST";
export const CREATE_DISBURSE_THRESHOLD_SUCCESS = "CREATE_DISBURSE_THRESHOLD_SUCCESS";
export const CREATE_DISBURSE_THRESHOLD_FAIL = "CREATE_DISBURSE_THRESHOLD_FAIL";

// get
export const DISBURSE_THRESHOLD_REQUEST = "DISBURSE_THRESHOLD_REQUEST";
export const DISBURSE_THRESHOLD_SUCCESS = "DISBURSE_THRESHOLD_SUCCESS";
export const DISBURSE_THRESHOLD_FAIL = "DISBURSE_THRESHOLD_FAIL";

// find
export const FIND_DISBURSE_THRESHOLD_REQUEST = "FIND_DISBURSE_THRESHOLD_REQUEST";
export const FIND_DISBURSE_THRESHOLD_SUCCESS = "FIND_DISBURSE_THRESHOLD_SUCCESS";
export const FIND_DISBURSE_THRESHOLD_FAIL = "FIND_DISBURSE_THRESHOLD_FAIL";

// update
export const UPDATE_DISBURSE_THRESHOLD_REQUEST = "UPDATE_DISBURSE_THRESHOLD_REQUEST";
export const UPDATE_DISBURSE_THRESHOLD_SUCCESS = "UPDATE_DISBURSE_THRESHOLD_SUCCESS";
export const UPDATE_DISBURSE_THRESHOLD_FAIL = "UPDATE_DISBURSE_THRESHOLD_FAIL";

// delete
export const DELETE_DISBURSE_THRESHOLD_REQUEST = "DELETE_DISBURSE_THRESHOLD_REQUEST";
export const DELETE_DISBURSE_THRESHOLD_SUCCESS = "DELETE_DISBURSE_THRESHOLD_SUCCESS";
export const DELETE_DISBURSE_THRESHOLD_FAIL = "DELETE_DISBURSE_THRESHOLD_FAIL";

export const CLEAR_ERROR = "CLEAR_ERROR";
